import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom'
import { LoadingButton } from '@mui/lab';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Cookies } from 'react-cookie';
import {useParams,useLocation } from 'react-router-dom'
export default function ResetForgetPassUser() {
 
   
    const [user, setUser] = useState({
       
        NewPassword: '',
        ConfirmPassword: ''
    });
    const { search } = useLocation();
    console.log(search.split('&')[0].split('?')[1].split('=')[1]);
    const UserCode = search.split('&')[0].split('?')[1].split('=')[1]
    console.log(search.split('&')[1].split('=')[1]);
    const Token = search.split('&')[1].split('=')[1]



    const inputRefs = useRef([]);

    //const Token = cookies.get('token');
    /*let UserCode = cookies.get('UserCode');*/
    const [isLoading, setIsLoading] = useState(false);




    const handleForgetPassword = async (e) => {
        e.preventDefault();
        let data = {
            Token: Token,
            UserCode,
            NewPassword: user.NewPassword,
            ConfirmPassword: user.ConfirmPassword
        }
        await fetch('/api/UserLogin/UpdateForgotPasswordUser', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            let res = await response.json();
            if (res.status === "SUCCESS") {

                toast.success(res.message, { position: 'top-center' })
            } else if (res.status === "ERROR") {
                toast.error(res.message, {
                    position: 'top-center'
                })
                inputRefs.current[res.focus].focus()
            }
        }).catch((err) => {
            toast.error(err, {
                position: 'top-center'
            });
        })
    };

    //useEffect(() => {
    //    if (!UserCode && !Token) {
    //        setIsLoading(true);
    //        setTimeout(() => {
    //            setIsLoading(false);
    //            alert(`Your link has been expired!\nRedirect to login...`)

    //        }, 5000);
    //    } else {
    //        setTimeout(() => {
    //            setIsLoading(false);
    //        }, 5000)
    //    }
    //}, []);

    return (
        <>
            <div className="container-fluid bg-login vh-100 d-flex justify-content-center align-items-center" >
                <div className="row" data-aos="zoom-in" data-aos-duration="1000" >
                    <div className="col-sm-3 px-4 py-5 main-login text-black rounded">
                        <div className=''>
                            <img src="./assets/img/Trackmate-logo.png" className='img1' alt="..." />
                        </div>
                        <div className="">
                            <form method='POST' >
                                <h5 className=" fs-4 my-2 text-center" style={{ textShadow: '2px 2px 2px var(--mycolorFilterCheckText)' }}>Forget Password </h5>
                                <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                    <div className="fields">
                                        <label className="form-label">User Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            name='userCode'
                                            placeholder='User Code'
                                            maxLength='9'
                                            defaultValue={UserCode}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                    <div className="fields">
                                        <label className="form-label">New Password</label>
                                        <input
                                            ref={ref => (inputRefs.current['txtNewPassword'] = ref)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    inputRefs.current['txtConfirmPassword'].focus();
                                                };
                                            }}
                                            type="password"
                                            className="form-control"
                                            autoComplete="off"
                                            placeholder='New Password'
                                            maxLength='20'
                                            name='NewPassword'
                                            value={user.Newpassword}
                                            onChange={(e) => setUser({ ...user, NewPassword: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                    <div className="fields">
                                        <label className="form-label">Confirm Password</label>
                                        <input
                                            ref={ref => (inputRefs.current['txtNewPassword'] = ref)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    inputRefs.current['txtConfirmPassword'].focus();
                                                };
                                            }}
                                            type="password"
                                            className="form-control"
                                            autoComplete="off"
                                            placeholder='Confirm Password'
                                            maxLength='20'
                                            name='ConfirmPassword'
                                            value={user.ConfirmPassword}
                                            onChange={(e) => setUser({ ...user, ConfirmPassword: e.target.value })}

                                        />
                                    </div>
                                </div>
                                <div className="py-2 loading">
                                    <LoadingButton style={{ background: "var(--mycolorFilterCheckText)" }} loadingPosition='center' onClick={handleForgetPassword} className=' py-1' variant="contained"> Submit </LoadingButton>
                                </div>
                                <Link to={'/login'} className="text-light" style={{ fontSize: "14px" }}>
                                    Back to Login
                                </Link>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer theme='colored' />
        </>
    );
}







